import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useGetFuelUsersQuery } from "../fuelApi";

// Searchable user picker over GET /fuel/users. That endpoint returns at most
// 200 rows, so typing searches server-side (debounced) instead of filtering
// whatever first page happened to load. The option value is the userId - the
// name is display text only, never identity.
const FuelUserSelect = ({ value, onChange, excludeUserIds, placeholder = "Search a user…", inModal = false, skip = false, compact = false }) => {
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const handle = setTimeout(() => setSearch(searchInput.trim()), 400);
    return () => clearTimeout(handle);
  }, [searchInput]);

  const { data: users = [], isFetching } = useGetFuelUsersQuery({ search: search || undefined }, { skip });
  const options = users
    .filter((u) => !excludeUserIds?.has(u.userId))
    .map((u) => ({ value: u.userId, label: `${u.userFullName || u.username} (${u.username})` }));

  return (
    <Select
      classNamePrefix="react-select"
      options={options}
      value={value}
      onChange={onChange}
      onInputChange={(text, meta) => {
        if (meta.action === "input-change") setSearchInput(text);
      }}
      // already filtered server-side
      filterOption={null}
      isLoading={isFetching}
      isClearable
      placeholder={placeholder}
      noOptionsMessage={() => "No matching users"}
      // a react-bootstrap modal body would clip the menu
      menuPortalTarget={inModal ? document.body : undefined}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 2000 }),
        ...(compact ? { control: (base) => ({ ...base, minHeight: 34, height: 34 }), valueContainer: (base) => ({ ...base, padding: "0 8px" }), indicatorsContainer: (base) => ({ ...base, height: 32 }) } : {}),
      }}
    />
  );
};

export default FuelUserSelect;
